<svg viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-6.969 8.002a7 7 0 0 1 13.938.002h1.004A8 8 0 0 0 .027 16h1.004zM8 9.667a7 7 0 0 1 6.97 6.337h1.003A8 8 0 0 0 .027 16h1.004A7 7 0 0 1 8 9.668z"/>
</svg>
